import { isServer } from 'src/shared/utils/environment';

// Document referrer is not always available when in an iframe as it is
// dependent on the referrer policy. When it is not available, return the fallback
// value
export const getReferrerHostname = (fallback = '') =>
  !isServer() && document.referrer
    ? new URL(document.referrer).hostname
    : fallback;
